"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLogSwipeSpeed = exports.MobileLogSwipeDirection = exports.MobileLogDeviceType = exports.MobileLogConnectivity = exports.MobileLogType = void 0;
var MobileLogType;
(function (MobileLogType) {
    MobileLogType[MobileLogType["AppStart"] = 0] = "AppStart";
    MobileLogType[MobileLogType["AppShow"] = 1] = "AppShow";
    MobileLogType[MobileLogType["AppHide"] = 2] = "AppHide";
    MobileLogType[MobileLogType["ScreenView"] = 3] = "ScreenView";
    MobileLogType[MobileLogType["Tap"] = 4] = "Tap";
    MobileLogType[MobileLogType["Swipe"] = 5] = "Swipe";
    MobileLogType[MobileLogType["LongPress"] = 6] = "LongPress";
    MobileLogType[MobileLogType["Transaction"] = 7] = "Transaction";
    MobileLogType[MobileLogType["DynamicVariable"] = 8] = "DynamicVariable";
})(MobileLogType = exports.MobileLogType || (exports.MobileLogType = {}));
var MobileLogConnectivity;
(function (MobileLogConnectivity) {
    MobileLogConnectivity["Offline"] = "MOBILE_LOG.CONNECTIVITY.OFFLINE";
    MobileLogConnectivity["Error"] = "MOBILE_LOG.CONNECTIVITY.ERROR";
    MobileLogConnectivity["WiFi"] = "MOBILE_LOG.CONNECTIVITY.WIFI";
    MobileLogConnectivity["2G"] = "2G";
    MobileLogConnectivity["3G"] = "3G";
    MobileLogConnectivity["4G"] = "4G";
})(MobileLogConnectivity = exports.MobileLogConnectivity || (exports.MobileLogConnectivity = {}));
var MobileLogDeviceType;
(function (MobileLogDeviceType) {
    MobileLogDeviceType["Smartphone"] = "MOBILE_LOG.DEVICE_TYPE.SMARTPHONE";
    MobileLogDeviceType["Tablet"] = "MOBILE_LOG.DEVICE_TYPE.TABLET";
})(MobileLogDeviceType = exports.MobileLogDeviceType || (exports.MobileLogDeviceType = {}));
var MobileLogSwipeDirection;
(function (MobileLogSwipeDirection) {
    MobileLogSwipeDirection["Up"] = "MOBILE_LOG.SWIPE_DIRECTION.UP";
    MobileLogSwipeDirection["Down"] = "MOBILE_LOG.SWIPE_DIRECTION.DOWN";
    MobileLogSwipeDirection["Left"] = "MOBILE_LOG.SWIPE_DIRECTION.LEFT";
    MobileLogSwipeDirection["Right"] = "MOBILE_LOG.SWIPE_DIRECTION.RIGHT";
})(MobileLogSwipeDirection = exports.MobileLogSwipeDirection || (exports.MobileLogSwipeDirection = {}));
var MobileLogSwipeSpeed;
(function (MobileLogSwipeSpeed) {
    MobileLogSwipeSpeed["Fast"] = "MOBILE_LOG.SWIPE_SPEED.FAST";
    MobileLogSwipeSpeed["Slow"] = "MOBILE_LOG.SWIPE_SPEED.SLOW";
})(MobileLogSwipeSpeed = exports.MobileLogSwipeSpeed || (exports.MobileLogSwipeSpeed = {}));
//# sourceMappingURL=index.js.map